import { icons } from '@/assets/json/qxicon'
import {
	todayTime,
	GetPreMonthDay,
	GetNextMonthDay,
	getFormatDate,
} from "../../../times/moment";
export default {
	methods: {
		// 获取头部站点下拉选
		getOrgids(isFen = false) {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userInfos = JSON.parse(userInfo)
			let params = {
				orgId: '',
			}
			if (isFen) {
				params.orgId = this.allOrgId
			} else {
				params.orgId = userInfos.orgId
			}
			this.$http
				.getAction(this.$api.qxfindDeviceByOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgSelect = datas || []
						this.isorgSelectData = true
						if (datas && datas.length) {
							this.$set(this.selectForm, 'facId', datas[0]['facId'])

							// 获取页面上相关的其它数据
							setTimeout(() => {
								// 获取详情数据
								this.getInfos()
								// 获取采集项
								this.getItemsSelect()
							}, 300)
						} else {
							this.orgSelect = []
							this.isorgSelectData = false
							this.loading = false
							this.$set(this.selectForm, 'facId', '')
						}
					} else {
						this.orgSelect = []
						this.isorgSelectData = false
						this.loading = false
					}
				})
				.catch(() => {
					this.orgSelect = []
					this.isorgSelectData = false
					this.loading = false
				})
		},
		getAllOrgids() {
			let userInfo = this.getItem('wlwUserInfo') || {}
			let userOrg = this.getItem('wlwOrg') || {}
			let userOrgs = JSON.parse(userOrg)
			let userInfos = JSON.parse(userInfo)
			let params = {
				parentOrgId: userInfos.orgId,
				type: '2',
			}
			this.$http
				.getAction(this.$api.findChildOrgByParentOrgId, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || []
						this.orgAllSelect = datas || []
						this.isorgSelectData = true
						if (datas && datas.length) {
							this.allOrgId = datas[0]['orgId']
							this.getOrgids(true)
						} else {
							this.loading = false
						}
					} else {
						this.orgSelect = []
						this.isorgSelectData = false
						this.loading = false
					}
				})
				.catch(() => {
					this.isorgSelectData = false
					this.orgSelect = []
					this.loading = false
				})
		},
		// 获取详情列表数据
		getInfos() {
			let params = this.selectForm
			this.$http
				.getAction(this.$api.qxlatestDeviceData, params)
				.then((res) => {
					console.log(res)
					if (res.meta.success) {
						let datas = res.data || {}
						this.infoData = datas || {}
						if (datas.sensorVOs && datas.sensorVOs.length) {
							this.isWarn = false

							this.infoList = datas.sensorVOs
							this.isinfoListData = true
							// 添加图片
							this.infoList.forEach((item, index) => {
								let iconIndex = this.imgList.findIndex((item2) => {
									return item.key == item2.key
								})
								if (iconIndex > -1) {
									item.path = this.imgList[iconIndex]['path']
								} else {
									let iconIndexTwo = this.imgList.findIndex((item2) => {
										return (
											item.key.indexOf(item2.key) > -1 ||
											item2.key.indexOf(item.key) > -1
										)
									})
									if (iconIndexTwo > -1) {
										item.path = this.imgList[iconIndexTwo]['path']
									} else {
										if (icons[item.key]) {
											item.path = icons[item.key]
										} else {
											item.path = require('@/assets/image/qx/icon_yw.png')
										}
									}
								}
								// this.imgList.forEach((item2, index2) => {
								// 	if (item.key == item2.key) {
								// 		item.path = item2.path
								// 	}
								// })
								if (item.key == 'FX') {
									item.value = this.fengChange(item.value)
									item.unitName = ''
								}
							})
						} else {
							this.isWarn = true
							this.infoData = {}
							this.infoList = []
							this.isinfoListData = false
						}
					} else {
						this.isWarn = true
						this.infoData = {}
						this.infoList = []
						this.isinfoListData = false
					}
				})
				.catch(() => {
					this.infoData = {}
					this.infoList = []
					this.isinfoListData = false
				})
				.finally((err) => {
					setTimeout(() => {
						this.loading = false
					}, 500)
				})
		},
		// 获取采集项
		getItemsSelect() {
			let params = this.selectForm
			this.$http
				.getAction(this.$api.qxgetDeviceItems, params)
				.then((res) => {
					if (res.meta.success) {
						this.isShowLine = true
						let datas = res.data || []
						if (datas && datas.length) {
							this.itemSelect = datas
							let infoList = JSON.parse(JSON.stringify(datas))
							let infoLists = []
							this.$set(this.queryParam, 'listparam', datas[0]['itemCode'])

							// 判断上面的详情是否有数据,没有数据设置占位空数据
							setTimeout(() => {
								infoList.forEach((item) => {
									let iconIndex = this.imgList.findIndex((item2) => {
										return item.itemCode == item2.key
									})
									if (iconIndex > -1) {
										item.path = this.imgList[iconIndex]['path']
									} else {
										let iconIndexTwo = this.imgList.findIndex(
											(item2) => {
												return (
													item.itemCode.indexOf(item2.key) >
													-1 ||
													item2.key.indexOf(item.itemCode) > -1
												)
											}
										)
										if (iconIndexTwo > -1) {
											item.path = this.imgList[iconIndexTwo]['path']
										} else {
											if (icons[item.itemCode]) {
												item.path = icons[item.itemCode]
											} else {
												item.path = require('@/assets/image/qx/icon_yw.png')
											}
										}
									}
									if (item.itemCode == 'FX') {
										item.value = this.fengChange()
										item.itemUnitCode = ''
									}

									infoLists.push({
										name: item.itemName,
										value: '--',
										unitName: item.itemUnitCode,
										path: item.path,
									})
								})
								console.log(infoLists)
								if (!this.isinfoListData) {
									this.infoList = infoLists
								}
							}, 300)
							this.$nextTick(() => {
								// 请求右下角折线图数据
								this.getLineData()
							})
						} else {
							this.isShowLine = false
							this.itemSelect = []
							this.$set(this.queryParam, 'listparam', '')
						}
					} else {
						this.isShowLine = false
						this.itemsSelect = []
						this.$set(this.queryParam, 'listparam', '')
					}
				})
				.catch(() => {
					this.isShowLine = false
					this.itemsSelect = []
					this.$set(this.queryParam, 'listparam', '')
				})
		},
		// 分公司网点下拉选选择
		changeAllOrg(val) {
			this.allOrgId = val
			console.log(val)
			this.getOrgids(true)
		},
		// 头部选择
		changeFacid(value) {
			console.log(value)
			// 获取详情数据
			this.getInfos()
			// 获取采集项
			this.getItemsSelect()
		},
		// 查询点击
		searchTap() {
			let miao = this.queryParam.startTime.split(" ")[1] || "00:00:00";
			let preMonthDay = new Date(
				GetNextMonthDay(getFormatDate(this.queryParam.startTime), 6) +
				" " +
				miao
			); //6个月之后的日期
			let startTimeCuo = new Date(this.queryParam.endTime).getTime();
			if (startTimeCuo >= preMonthDay.getTime()) {
				this.$message("选择时间跨度范围不允许超过6个月", "warning");
				return false;
			}
			this.getLineData()
		},
		// 获取折线图数据
		getLineData() {
			let listparam = this.queryParam.listparam
			let deviceCode = this.selectForm.facId
			console.log(deviceCode)
			let params = Object.assign({}, this.queryParam, this.selectForm)
			this.$set(params, 'list', listparam.split())
			this.$delete(params, 'listparam')
			this.$set(params, 'deviceCode', deviceCode)
			this.$delete(params, 'facId')
			console.log(listparam)
			console.log(params)
			console.log(this.queryParam)
			let xAxis = []
			let yAxis = []
			let yName = ''
			let yUnit = ''
			this.$http
				.postAction(this.url.lineChart, params)
				.then(
					(res) => {
						if (res.meta.success) {
							let datas = res.data || {}
							if (!Object.keys(datas).length) {
								this.isShowLine = false
								return
							}
							Object.keys(datas).forEach((key) => {
								xAxis.push(key)
								yAxis.push(datas[key][0]['acquisitionData'])
							})
							if (xAxis.length) {
								yName = datas[xAxis[0]][0]['acquisitionItemName']
								yUnit = datas[xAxis[0]][0]['acquisitionItemUnitCode']
							}
							if (xAxis.length) {
								this.isShowLine = true
								this.$nextTick(() => {
									setTimeout(() => {
										this.lineChart(xAxis, yAxis, yName, yUnit)
									}, 200)
								})
							} else {
								this.isShowLine = false
							}
						} else {
							this.isShowLine = false
						}
					},
					(error) => {
						console.log('error')
						this.isShowLine = false
					}
				)
				.finally(() => { })
		},
		// 左侧折线图
		// 折线图绘制
		lineChart(xData, yData, yName, yUnit) {
			let yUnitTxt
			console.log(yUnit.length)
			if (yUnit != ' ') {
				yUnitTxt = '（' + yUnit + '）'
			} else {
				yUnitTxt = ''
			}
			const _this = this
			let maxY = Math.max(...yData)
			let symbolSize = 60
			let symbolFont = 12
			let tops = '16%'
			if (maxY.length <= 2) {
				symbolSize = 40
				symbolFont = 16
			} else if (maxY.length > 2 && maxY.length <= 3) {
				symbolSize = 50
				symbolFont = 14
			} else if (maxY.length > 3 && maxY.length < 4) {
				symbolSize = 60
				symbolFont = 12
				tops = '18%'
			} else {
				symbolSize = 65
				symbolFont = 12
				tops = '20%'
			}
			let myChart = this.$echarts.init(this.$refs.chartLine)
			let option = {
				tooltip: {
					show: true,
					trigger: 'axis',
					backgroundColor: '#fff',
					padding: [14, 17],
					axisPointer: {
						type: 'line',
						lineStyle: {
							color: '#DADADA',
							type: 'solid',
							width: 2,
						},
					},
					extraCssText:
						'box-shadow: 0px 0px 12px 0px rgba(76, 216, 179, 0.33);text-align:left;font-size:14px;color:#3F3F3F;letter-spacing: 1px;',
					formatter: function (param) {
						let infos = ''
						infos += `<div style="text-align:left;">${yName}：<span style="color:#2DAEA9">${param[0].value}${yUnit}</span></div><div style="margin-top:12px">${param[0].name}</div`
						return infos
					},
				},
				color: '#2DAEA9',
				grid: {
					left: '5%',
					bottom: '15%',
					top: tops,
					right: '6%',
				},
				xAxis: {
					type: 'category',
					data: xData,
					// 刻度线
					axisTick: {
						show: false,
					},
					axisLine: {
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
						lineHeight: 30,
					},
					boundaryGap: false,
				},
				yAxis: {
					type: 'value',
					name: yUnitTxt,
					nameTextStyle: {
						color: '#6B6B6B',
						fontSize: 14,
						align: 'right',
					},
					axisLabel: {
						color: '#6B6B6B',
						fontSize: 14,
					},
					axisLine: {
						show: true,
						lineStyle: {
							color: '#EDEDED',
							width: 2,
						},
					},
				},
				series: [
					{
						type: 'line',
						smooth: true,
						showSymbol: false,
						symbolSize: 10,
						animation: true,
						animationThreshold: 5000,
						animationDuration: 5000,
						itemStyle: {
							borderColor: '#2DAEA9',
							borderWidth: 8,
						},
						areaStyle: {
							color: 'rgba(45, 174, 169, 0.26)',
						},
						lineStyle: {
							width: 4,
						},
						markPoint: {
							symbolSize: symbolSize,
							label: {
								color: '#fff',
								fontSize: symbolFont,
								position: 'inside',
								// show:false
							},
							data: [
								{
									type: 'max',
									name: '最大值',
									itemStyle: {
										color: '#FF648C',
									},
								},
								{
									type: 'min',
									name: '最小值',
									itemStyle: {
										color: '#3EA2EF',
									},
								},
							],
						},
						markLine: {
							data: [
								{
									type: 'average',
									name: '平均值',
									lineStyle: {
										type: 'solid',
										color: '#FFA800',
									},
									label: {
										position: 'middle',
										formatter: '平均值:{c}',
										color: '#FFA800',
										distance: 10,
										fontSize: 16,
									},
									symbol: 'none',
								},
							],
						},
						data: yData,
					},
				],
			}
			myChart.clear()
			myChart.setOption(option)
			window.addEventListener('resize', function () {
				myChart.resize()
			})
		},
		// 风向度数转方向
		fengChange(value) {
			console.log(value)
			var str = ''
			value = (value - 0).toFixed(0)
			if (value >= 360) {
				value = value - 360
			}
			if (value > 0 && value < 90) {
				str = '东北'
			}
			if (value > 90 && value < 180) {
				str = '东南'
			}
			if (value > 180 && value < 270) {
				str = '西南'
			}
			if (value > 270 && value < 360) {
				str = '西北'
			}
			if (value == 0) {
				str = '北'
			}
			if (value == 90) {
				str = '东'
			}
			if (value == 180) {
				str = '南'
			}
			if (value == 270) {
				str = '西'
			}
			console.log(str)
			return str
		},
	},
}
